import { render, staticRenderFns } from "./place_holder.vue?vue&type=template&id=481ec73e&scoped=true&"
import script from "./place_holder.vue?vue&type=script&lang=js&"
export * from "./place_holder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ec73e",
  null
  
)

export default component.exports